import { Stack } from '@mui/system'
import { OrderResponseDto } from '@planning/app/api'
import { usePlanningStore } from '@planning/AppProvider'
import { StowagePositionSubForm } from '@planning/components/stowage-position/organisms/StowagePositionSubForm'
import { IInspectContainerFormData } from '@planning/pages/TallymanV2/Components'
import { orderService } from '@planning/services'
import { useTranslate } from '@tolgee/react'
import { useMinimalsTheme } from '@tom-ui/ui'
import { appStore, useFormStore } from '@tom-ui/utils'
import { useCallback } from 'react'

export const useUpdateOrderStowagePosition = () => {
  const { t } = useTranslate()
  const theme = useMinimalsTheme()
  const { appViewStore } = usePlanningStore()
  const stowagePositionFormStore = useFormStore<IInspectContainerFormData>()

  const onEditPostion = useCallback(
    async (title: string, order?: OrderResponseDto) => {
      const initialStowagePosition = order?.finalStowagePosition ?? order?.stowagePosition
      const isConfirmed = await appViewStore.setOpenConfirmDialog(
        true,
        <Stack p={theme.customSpacing.s}>
          <StowagePositionSubForm
            formStore={stowagePositionFormStore}
            name='stowagePosition'
            initialValue={initialStowagePosition}
          />
        </Stack>,
        title,
        '',
        {
          primaryActionText: t('save', 'Save'),
          secondaryActionText: t('close', 'Close'),
        },
      )
      if (isConfirmed && order?.id) {
        const stowagePosition = stowagePositionFormStore.data.stowagePosition
        await appStore.requestWithLoader(
          async () =>
            await orderService.updateStowagePosition({
              id: order.id,
              stowagePosition: stowagePosition!,
            }),
        )
      }
    },
    [appViewStore, stowagePositionFormStore, t, theme],
  )

  return { onEditPostion }
}
